export interface IAuthenticatedUser {
    company: string;
    email: string;
    first_name: string;
    last_name: string;
    id: number;
    is_active: boolean;
    is_admin: boolean;
    is_staff: boolean;
    is_superuser: boolean;
}

export class AuthenticatedUser {
    company: string;
    email: string;
    firstName: string;
    lastName: string;
    userId: number;
    isActive: boolean;
    isAdmin: boolean;
    isStaff: boolean;
    isSuperuser: boolean;

    constructor(params?: Partial<IAuthenticatedUser>) {
        this.company = params.company;
        this.email = params.email;
        this.firstName = params.first_name;
        this.lastName = params.last_name;
        this.userId = params.id;
        this.isActive = params.is_active;
        this.isAdmin = params.is_admin;
        this.isSuperuser = params.is_superuser;
    }
}

